angular.module('bmsApp.trugreen.inventory').controller('TGInventoryIndexCtrl',
	function ($state,
			  $scope,
			  $cookies,
			  $location,
			  ngTableParams,
			  TGInventorySvc) {

	var defaultInventoryParams = function () {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			filter: {

			}
		}
	};

	var initialInventoryParams = function () {
		if (angular.isDefined($cookies.inventoryIndexParams)) {
			return angular.extend({}, defaultInventoryParams(), JSON.parse($cookies.inventoryIndexParams));
		}
		else {
			return angular.extend({}, defaultInventoryParams());
		}
	};

	var params = initialInventoryParams();
	$scope.inventoryFilters = angular.copy(params.filter);
	$scope.tableParams = new ngTableParams(params, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$scope.updating = true;
			TGInventorySvc.index(params.$params)
				.then(function (response) {
					let products = response.data.tg_inventory_products;
					calculateQuantityCost(products);
					self.total_count = response.data.tg_inventory_products_count;
					params.total(response.data.tg_inventory_products_count);
					$defer.resolve(products);
					$scope.updating = false;
					//emit data to the sidebar
					$scope.$emit("InventoryIndexSideData", {
						"totalProducts":response.data.tg_inventory_products_count,
						"pan": defaultInventoryParams()
					});
				});
		}
	});

	function rowClicked (product) {
		$state.go('main.trugreen.inventory.index.edit', {inventoryId: product.id});
	}
	function filterChanged() {
		$scope.tableParams.$params.filter.search = self.searchText;
	}

	function calculateQuantityCost(products) {
		angular.forEach(products, (product) => {
			if (angular.isObject(product.product_attr)) {
				let unitPerApplicationm2 = product.product_attr.application * product.product_attr.application_per_m2;
				let applicationsInStock = product.stock_count / unitPerApplicationm2;

				let cost = applicationsInStock * product.product_attr.cost_per_m2;
					angular.extend(product, {
					cost: cost,
				});
			}
		});
	}

	var self = $scope.TGInventoryIndexCtrl = {
		methods: {
			rowClicked: rowClicked,
			filterChanged: filterChanged
		},
		pan: {
			page: 1,
			limit: 15,
			count: 15
		},
		inventoryProducts: null,
		tableParams: undefined,
		total_count: 0
	};
});